<script>
import BarGraphStatisticAttestation from "./BarGraphStatisticAttestation.vue";

export default {
  name: "CardStatisticAttestation",
  components: {BarGraphStatisticAttestation},

  props: {
    loading: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
    };
  }
}
</script>

<template>
  <v-card>

    <v-card-text v-if="loading" class="d-flex align-center justify-center" style="height: 450px">
      <v-progress-circular
        :size="70"
        :width="7"
        color="teal darken-3"
        indeterminate
      ></v-progress-circular>
    </v-card-text>

    <template v-else>
      <slot></slot>
    </template>
  </v-card>
</template>

<style scoped>

</style>